package org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class BillSearchTableHeadersEnum(
    val key: String,
    val isNumeric: Boolean,
) {
    DATE(
        key = "date",
        isNumeric = false
    ),
    TIME(
        key = "time",
        isNumeric = false
    ),
    NUMBER(
        key = "number",
        isNumeric = true,
    ),
    DEVICES(
        key = "devices",
        isNumeric = false
    ),
    TABLE_NUMBER(
        key = "tableNumber",
        isNumeric = true
    ),
    USER_NAME(
        key = "userName",
        isNumeric = false
    ),
    CANCELLATION(
        key = "cancellation",
        isNumeric = false
    ),
    TOTAL(
        key = "total",
        isNumeric = true,
    );

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            DATE -> strings.date
            TIME -> strings.time
            TABLE_NUMBER -> strings.tableNumber
            DEVICES -> strings.devices
            NUMBER -> strings.receiptNo
            USER_NAME -> strings.userName
            CANCELLATION -> strings.cancelled
            TOTAL -> strings.total
        }
    }

}